/**
 * Builders that convert typed API objects into metrics event payloads.
 *
 * Replaces the Spaces 2 approach of reading data-* attributes off DOM nodes
 * with jQuery (ui/scripts/v2/metrics/metrics.js). Field names and the overall
 * shape are preserved for consumer compatibility.
 */

import type { ApiUnit, ApiFloorPlan } from '@/types/api'
import type { MetricsUnit, MetricsPlan } from '@/types/metrics'

export function toMetricsUnit (unit: ApiUnit): MetricsUnit {
	const area = Number(unit.area) || 0
	const fp = unit.floor_plan

	return {
		id: unit.id,
		unitNumber: String(unit.unit_number),
		area,
		areaDisplay: `${area.toLocaleString('en-US')} Sq. Ft.`,
		price: unit.price,
		priceDisplay: unit.price_string,
		availableOn: unit.available_on,
		availableOnDisplay: unit.available_on_string ?? '',
		floorPlan: {
			id: fp?.id ?? unit.floor_id ?? '',
			name: fp?.name ?? unit.plan_name ?? '',
			bedroomCount: Number(fp?.bedroom_count ?? unit.bedroom_count) || 0,
			bathroomCount: Number(fp?.bathroom_count ?? unit.bathroom_count) || 0
		}
	}
}

export function toMetricsPlan (plan: ApiFloorPlan): MetricsPlan {
	return {
		id: plan.id,
		name: plan.name,
		bedroomCount: Number(plan.bedroom_count) || 0,
		bathroomCount: Number(plan.bathroom_count) || 0,
		// The plan list type carries no soonest-available date; emit null for now.
		availableOn: null,
		price: plan.min_price
	}
}
